import UI from "./base/UI";
import gsap, {Power2} from 'gsap';
import { isA11yCheckVersion } from "../functions/a11y.ui";
/**
 * Tooltip
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_tooltip.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_tooltip.html)
*/
class Tooltip extends UI {
    defaults = {};

    constructor(el, options) {
        super('tooltip', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};

        this.render();
    }

    update() {

    }

    render() {
        if(this.$el.find('.btn-tooltip').attr('aria-expanded') === undefined) {
            this.$el.find('.btn-tooltip').attr('aria-expanded', false);
        }

        // 닫기 버튼이 없는 툴팁
        // if(this.$el.find('.btn-tooltip-close').length === 0) {
        //     this.closeAuto();
        // }

        this.detachEvents();
        this.attachEvents();
    }

    attachEvents() {
        // 툴팁 아이콘 타입
        this.$el.on(`click${this.eventId}`, '.btn-tooltip', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            $('.ui-tooltip').each((idx,el)=>{
                if ($(el).attr('data-autoClose')  != undefined ){
                    $(el).data('ui').close()
                }
                // console.log($(el))
            })
            $this.hasClass('open') ? this.close() : this.open();
            e.stopPropagation();
            return false;
        });


        this.$el.on(`click${this.eventId}`, '.btn-tooltip-close', (e) => {
            e.preventDefault();
            this.close();
            e.stopPropagation();
            return false;
        });
    }
    /**
     * 일반 open
     * @example 
     * $('.ui-tooltip').data('ui').open();
     */
    open() {
        if (this.$el.find('.btn-tooltip').length > 0) {
            /*! s: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
            if(isA11yCheckVersion()){
                this.isA11yFocusAcess('open', this.$el);
            }else{ //접근성 이전 코드
                this.$el.find('.btn-tooltip').addClass('open');
                this.$el.find('.btn-tooltip').attr('aria-expanded', true);
            }
            /*! e: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
        }else{
            this.$el.find('.tooltip-area').show();
        }
    }
    /**
     * 일반 close
     * @param {boolean} animate 'true/false'
     * @param {function} callback 콜백함수 
     * @example 
     * $('.ui-tooltip').data('ui').close(false, function(){
     * 
     * });
     */
    close(animate = false, callback = () => {}) {
        if (this.$el.find('.btn-tooltip').length > 0) {
            /*! s: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
            this.$el.find('.btn-tooltip').removeClass('open');
            /*! e: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
        }else {
            if(animate){
                gsap.to(this.$el.find('.tooltip-area'), {
                    duration: 0.4, height: 0, overflow: 'hidden', ease: Power2.easeOut, onComplete: callback
                });
            }else{
                this.$el.find('.tooltip-area').hide();
            }
        }

        if(isA11yCheckVersion()){
            this.$el?.find('.btn-tooltip')?.focus();
            this.$el.find('.btn-tooltip').attr('aria-expanded', false); //A11YTASK-486 (2025.04.16)
        }
    }
    /**
     * n초뒤 open
     * @param {number} ms n초뒤 open 툴팁  ms 단위 
     * @example 
     * $('.ui-tooltip').data('ui').openAuto(3000);
     */
    openAuto(ms = 3000) {// N초 뒤 생성되는 툴팁
        gsap.to(this.$el.find('.tooltip-area'), {
            display:'block', delay: ms/1000, duration: 0.5, ease: Power2.easeInOut, autoAlpha: 1
        });
    }
    /**
     * n초뒤 close
     * @param {number} ms n초뒤 close 툴팁  ms 단위 
     * @example 
     * $('.ui-tooltip').data('ui').closeAuto(3000);
     */
    closeAuto(ms = 3000) { // N초 뒤 사라지는 툴팁
        gsap.to(this.$el.find('.tooltip-area'), {
            display:'none', delay: ms/1000, duration: 0.5, ease: Power2.easeInOut, autoAlpha: 0
        });
    }


    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    /*! s: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
    async isA11yFocusAcess(type='open', $el){
        if(type === 'open'){
            //툴팁 열기
            $el.find('.btn-tooltip').addClass('open');
            $el.find('.btn-tooltip').attr('aria-expanded', true);

            const delay = new Promise((resolve) => setTimeout(resolve, 300));

           
            $el?.find('.btn-tooltip')?.focus(); //A11YTASK-486 : 접근성대응(2025-05-09)
            await delay;

            // $el?.find('.btn-tooltip-close')?.focus(); //A11YTASK-486 : 접근성대응(2025-05-09)
        }else{
            //툴팁 닫기
            $el?.find('.btn-tooltip')?.attr('aria-expanded', false);

            if($el?.find('.btn-tooltip')?.length > 0){
                $el?.find('.tooltip-area')?.attr('style','display:block');
                $el?.find('.btn-tooltip')?.focus();

                const delay = new Promise((resolve) => setTimeout(resolve, 300));

                await delay;

                $el?.find('.tooltip-area')?.removeAttr('style');
                this?.$el?.find('.btn-tooltip')?.removeClass('open');
            }
        }
    }
    /*! e: FETASK-a11y page isA11yFocusAcess v.1.0.0 */
}

export default Tooltip;
